import { render, staticRenderFns } from "./quesSuccess8.vue?vue&type=template&id=4ae0898f"
import script from "./quesSuccess8.vue?vue&type=script&lang=js"
export * from "./quesSuccess8.vue?vue&type=script&lang=js"
import style0 from "./quesSuccess8.vue?vue&type=style&index=0&id=4ae0898f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports